import React, { useEffect, useState } from "react";
import "./Slider.css";
import Background from "../../images/Slider_img-1.png";
import Dashboard from "../../images/Dashboard_2.png";

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const slides = [
    {
      id: 1,
      type: "intro",
      background: Background,
      title: (
        <>
          Expert guidance
          <br />
          for the <span>care sector</span>
        </>
      ),
      description:
        "Total Care Advisory provides specialist consultancy services for care providers, healthcare organisations, and social care businesses across the UK. We are dedicated to enhancing compliance, operational efficiency, financial performance, and overall quality of care.",
    },

    {
      id: 2,
      type: "rota",
      tag: "BUILT FOR CARE PROVIDERS",
      title: (
        <>
          Smarter rotas.
          <br />
          Lower
          <br />
          costs. <span>Better care.</span>
        </>
      ),
      description:
        "Total Care Rota gives care homes and care providers one clear system for staffing, attendance, compliance, payroll-ready timesheets and workforce cost control.",
      image: Dashboard,
    },
  ];

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 7000);

    return () => clearInterval(interval);
  }, [isPaused, slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section
      className="home-slider"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="slider-track">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`home-slide ${
              index === currentSlide ? "active" : ""
            } ${slide.type}`}
            style={
              slide.background
                ? {
                    backgroundImage: `url(${slide.background})`,
                  }
                : {}
            }
          >
            {slide.type === "intro" && <div className="intro-overlay"></div>}

            <div className="slider-container">
              {slide.type === "intro" ? (
                <div className="intro-content">
                  <h1>{slide.title}</h1>

                  <p>{slide.description}</p>
                </div>
              ) : (
                <div className="rota-content">
                  <div className="rota-text">
                    <div className="slide-tag">{slide.tag}</div>

                    <h2>{slide.title}</h2>

                    <p>{slide.description}</p>

                    <div className="slider-buttons">
                      <a
                        href="mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo"
                        className="primary-btn"
                      >
                        Book Your Free Demo
                      </a>

                      <a href="Sub-Pages/Care_Home" className="secondary-btn">
                        Explore Features
                      </a>
                    </div>

                    <div className="feature-list">
                      <span>✓ Care-sector focused</span>
                      <span>✓ Fast implementation</span>
                      <span>✓ Multi-site ready</span>
                    </div>
                  </div>

                  <div className="rota-image">
                    <img src={slide.image} alt="Total Care Rota dashboard" />
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Previous */}
      <button
        className="slider-arrow prev-arrow"
        onClick={prevSlide}
        aria-label="Previous slide"
      >
        <span>‹</span>
      </button>

      {/* Next */}
      <button
        className="slider-arrow next-arrow"
        onClick={nextSlide}
        aria-label="Next slide"
      >
        <span>›</span>
      </button>

      {/* Dots */}
      <div className="slider-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`slider-dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Scroll Down */}
      <div className="scroll-down">
        <div className="mouse">
          <span></span>
        </div>

        <small>SCROLL DOWN</small>
      </div>
    </section>
  );
};

export default Slider;
